import { Controller } from 'stimulus'
import Google from 'mixins/google'

export default class extends Google(Controller) {

  static targets = ['map', 'markerTemplate']

  connect() {
    this.googleConnect()
  }

  disconnect() {
    google.maps.event.clearInstanceListeners(this.map)
  }

  googleConnected() {
    this.initMap()
  }

  initMap() {
    this.map = new google.maps.Map(this.element, {
      center: { lat: parseFloat(this.element.dataset.latitude), lng: parseFloat(this.element.dataset.longitude) },
      zoom: 14
    })

    this.marker = new google.maps.Marker({
      position: { lat: parseFloat(this.element.dataset.latitude), lng: parseFloat(this.element.dataset.longitude) },
      map: this.map
    })
  }
}
